import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Tag, Button, Spin, Icon, Tooltip, Progress } from 'antd';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import PostForm from '../../components/postupload/postform'
import PostCatUpload from '../../components/postupload/postcatupload'
const TabPane = Tabs.TabPane;

class PostUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabStyle: 'left'
    };
  }

  componentWillMount() {
    // eslint-disable-next-line no-undef
    const role = localStorage.getItem('role');
    if (role !== 'admin') {
      this.props.history.goBack();
    }
    this.switchTabStyle()
  }

  switchTabStyle = () => {
    let size = window.innerWidth
    if(size <= 415) {
      this.setState({
        tabStyle: 'top'
      })
    }
  }

  render() {
    const { tabStyle } = this.state
    return (
      <div className="postupload">
        <TopNav history={this.props.history} />
        <section className="postupload-main">
        <Tabs size="large" defaultActiveKey="1" tabPosition={tabStyle}>
            <TabPane tab="Create post" key="1">
              <Row>
                <Col lg={16} sm={24}>
                  <PostForm/>
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Create post category" key="2">
              <Row>
                <Col lg={16} sm={24}>
                  <PostCatUpload/>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </section>
        <Footer/>
      </div>
    )
  }
}

export default PostUpload